<script>
import {notificationMethods, smsMethods, customerMethods} from "@/state/helpers";

import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Gönderilen SMS Listesi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {

      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      smsTemplates: [],
      title: "Gönderilen SMS Listesi",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Gönderilen SMS'ler",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      addForm: {
        customers: [],
        message: "",
      },
      totalRows: 1,
      page: 1,
      perPage: 10,
      search:'',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "phone",
      sortDesc: false,
      fields: [
        {
          key: "customerId.name",
          label: "Müşteri",
          sortable: true,
        },/*{
          key: "updatedAt",
          label: "Tarih",
          sortable: true,
        },*/
        {
          key: "phone",
          label: "Telefon",
          sortable: false,
        },
        {
          key: "message",
          label: "Mesaj",
          sortable: false,
        },
        {
          key: "statusMessage",
          label: "Gönderim Durumu",
          sortable: false,
        },
        {
          key: "userId.name",
          label: "Gönderen",
          sortable: false,
        },
        {
          key: "createdAt",
          label:"Oluşturulma Tarihi",
          sortable: true,
        },
      ],
      pageInput:1,
      formSelectCustomers:[],
      selectedCustomers:[],
      allFormSelectCustomers:[],
      customerFilter:''
    };
  },
  validations: {
    addForm: {
      customers:{required},
      message: { required },
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
  },
  watch:{
    filter(newFilter) {
      if (newFilter.length) {
        this.filtreliVerileriGetir(newFilter);
      } else {
        this.getSendSms();
      }
    },

    customerFilter(newFilter){
      if (newFilter.length > 2) {
        this.getCustomersForFormSelect(newFilter)
      } else {
        this.formSelectCustomers = [];
      }
    },
    'addForm.customers': function(customers){
      this.formSelectCustomers = this.allFormSelectCustomers.filter(formCustomer=> !customers.includes(formCustomer.id))
    },
    page(newPage){
      this.pageInput=newPage;
      this.getSendSms(newPage);
    },
    search(newSearch){
      if(newSearch.length<1){
        if(this.page===1){
          this.getSendSms();
        }else{
          this.page=1;
        }
      }
    }
  },
  mounted() {
    this.getSendSms();
  },
  methods: {
    ...smsMethods,
    ...customerMethods,
    ...notificationMethods,
    resetForm() {
      this.addForm = {
        customers: [],
        message: "",
      };
      this.addSubmitted = false;

    },
    doSearch(){
      if(this.page===1){
        this.getSendSms();
      }else{
        this.page=1;
      }
    },
    getCustomersForFormSelect(){
      let filter = {search:this.customerFilter}
      this.fetchCustomers({listType:'select',...filter}).then(res=>{
        this.formSelectCustomers = res.docs.filter(customer=> !this.addForm.customers.includes(customer.id))
      })
    },

    getSendSms(page = this.page) {
      this.itemsLoaded = false;
      this.fetchSendSmsList({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        this.items = res.docs.map(elem => {
          return elem;
        })
        this.itemsLoaded = true;
      })
    },



    handleSubmit() {
      this.addSubmitted = true;
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {
        this.sendSms(this.addForm).then(()=>{
          this.toastMessage="Mesaj Gönderim İşlemi Başlatıldı";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.getSendSms();
          this.addForm.customers = [];
          this.addForm.message = "";
        })
      }
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  SMS Gönder
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="fields"
                  responsive="sm"
              >
                <template v-slot:cell(createdAt)="data">
                  {{data.item.createdAt| formatDate}}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'40px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"  class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Mesaj Gönder" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="customers">Gönderilecek Müşteriler</label>
                <b-dropdown :style="{border:'1px solid #ced4da',textAlign:'left'}" class=" d-flex customSelect" text="Müşterileri seçiniz"  variant="text-dark">
                  <form>
                    <input v-model="customerFilter" type="text" :style="{borderTop:'none'}"  class="dropdown-item" placeholder="ara...">
                  </form>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item class="w-100" @click="()=>{
                    customerFilter=''
                    selectedCustomers.push(customer)
                    addForm.customers.push(customer.id)
                  }" :key="customer.id" v-for="customer in formSelectCustomers">
                    {{customer.name}}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="d-flex mb-3 gap-2">
              <span :key="customer" v-for="customer in addForm.customers" class="badge badge-pill badge-soft-secondary font-size-14 d-flex align-items-center gap-2">{{ selectedCustomers.filter(formCustomer=>formCustomer.id===customer)[0].name}}
                 <i class="bx bx-plus" @click="()=>{
                   selectedCustomers = selectedCustomers.filter(item=>item.id!=customer)
                   addForm.customers = addForm.customers.filter(formCustomer=> formCustomer!=customer)
                 }" :style="{rotate:'45deg',fontWeight:'bold',cursor:'pointer'}"></i>
              </span>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="message">Mesaj Metni</label>
                <textarea
                    name="message"
                    id="message"
                    type="text"
                    autocomplete="off"
                    v-model="addForm.message"
                    class="form-control"
                    placeholder="Mesaj Metni giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.message.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.addForm.message.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.addForm.message.required">Mesaj Metni girilmesi gerekli bir alandır.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Gönder</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.customSelect .dropdown-menu{
  width:100% !important;
}
.customSelect .btn{
  text-align: left;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
